import ACTIONS from '@/store/storeActions';

const actions = {
  [ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS]: (context, payload) => {
    context.commit(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS, payload);
  },
  [ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE]: (context, payload) => {
    context.commit(ACTIONS.SET_CURRENT_EXERCISE_DOCUMENTS_LOADING_STATE, payload);
  }
}

export default actions
